import React from "react";
import Dropzone from "react-dropzone";
import IntlMessages from "util/IntlMessages";

class Accept extends React.Component {
  render() {
    const { imageName, imageid } = this.props;
    
    let url = null;
    let preview = null;
    if (imageName) {
      const { url: urlI, preview: previewI } = imageName;
      url = urlI;
      preview = previewI;
    }

    return (
      <div className="dropzone-card dropzone-card-width">
        <div className="dropzone">
        {url != null && (imageid != undefined && imageid == "") ?   <div className="dropzone-remove-img"><span className="span-img" onClick={this.props.handleRemove}></span></div> :null }
          <Dropzone accept="image/jpeg, image/png" onDrop={this.props.onDrop} multiple>
            {imageName ? (
               <img
                className="img-thumbnail img-container img-fluid "
                src={url || preview}
                alt="user"
              />
            ) : (
              <React.Fragment> 
                <p>
                  <IntlMessages id="vibo.dragAndDrop.selectMsg" />
                </p>
                <p className="mb-0">
                  {" "}
                  <IntlMessages id="vibo.dragAndDrop.uploadMsg" />
                </p>
              </React.Fragment>
            )}
          </Dropzone>
        </div>
      </div>
    );
  }
}

export default Accept;



// WEBPACK FOOTER //
// ./components/DragAndDropImage/index.js